import React, { Suspense, lazy } from "react";

import Loading from "@Core/Components/Loading";

const LoginWrapper = lazy(() =>
  import(/* webpackChunkName: "login" */ "./view")
);

const LoaderWrapper = (props) => {
  return (
    <>
      <Suspense fallback={<Loading />}>
        <LoginWrapper {...props} />
      </Suspense>
    </>
  );
};

export default LoaderWrapper;